import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  }
};

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    nonExplicitSupportedLngs: false,
    load: "languageOnly",
    cleanCode: true,
    fallbackLng: 'ru',
    resources,
    debug: false,
    detection: {
      order: ["localStorage", 'cookie'],
      caches: ["localStorage", 'cookie'],
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    whitelist: ['ru', 'en'],
  });

export default i18n;
